import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import ToastrAction from 'toastr/actions/ToastrAction'
import Checkbox from '../../../../components/forms/Checkbox'
import Select from '../../../../components/forms/Select'
import Job from '../../../dto/DtoJob'
import DtoParametrageDataType from '../../../../piezometry/dto/DtoParametrageDataType'
import { arrayOf, getSandreList } from '../../../../utils/StoreUtils'
import HydrometryAction from '../../../../hydrometry/actions/HydrometryAction'
import MultiContributorsAutocomplete from 'referencial/components/contributor/components/MultiContributorsAutocomplete'
import DtoSandreCode from '../../../../referencial/dto/DtoSandreCode'
import DtoContributor from '../../../../station/dto/DtoContributor'
import { getQualificationSelectOptions, getStatusSelectOptions } from '../../../../utils/StatusUtil'
import { SANDRE } from '../../../../referencial/constants/ReferencialConstants'
import ReferencialAction from '../../../../referencial/action/ReferencialAction'
import { getIntegrationModes } from '../../../../utils/JobUtils'
import { nbPerPageLabelMedium } from '../../../../referencial/constants/ReferencialConstants'
import { CardTable, NewTable } from '../../../../components/datatable/NewTable'
import { exportFile } from '../../../../utils/ExportDataUtil'
import IntegrationModeDialog from '../IntegrationModeDialog'
import { Button, Grid, Stack, Typography } from '@mui/material'
import { FieldsetMUI } from 'components/StyledElements'
import Input from 'components/forms/Input'


class TideGaugePanel extends Component {
    state = {
        measureOptions: [
            {
                value: '',
                label: i18n.noDataIntegration,
            },
            {
                value: 'dataIntegration',
                label: i18n.lastDataIntegration,
            },
            {
                value: 'dataFullIntegration',
                label: i18n.fullDataIntegration,
            },
        ],
        addCode: '',
    }

    componentDidMount() {
        if (!this.props.hydrometryDataTypes.length) {
            this.props.fetchHydrometryDataTypes()
        }
        if (!this.props.sandreCodes.length) {
            this.props.fetchSandreCodes()
        }
    }

    onDeleteCode = (s) => {
        if (this.props.isEditMode) {
            const codes = this.props.job.parameters.parameters.filter((code) => code !== s?.credentials?.value)
            this.props.addCode(codes)
        }
    }

    getDataTypes = type => {
        const { parameters } = this.props.job
        if (parameters.dataTypes && parameters.dataTypes.length) {
            return parameters.dataTypes.find(d => d.includes(type)) || ''
        }
        return ''
    }

    addCode = () => {
        if (this.props.isEditMode) {
            const code = this.state.addCode
            const exist = this.props.job.parameters.parameters.find(p => p.toLowerCase() == code.toLowerCase())
            if (!code) {
                this.props.toastrError(i18n.youMustEnterAtLeastOneCode)
            } else if (exist) {
                this.props.toastrError(i18n.youHaveAlreadyEnteredThisCode)
            } else {
                this.props.addCode([
                    code,
                    ...this.props.job.parameters.parameters,
                ])
                this.setState({ addCode: '' })
            }
        }
    }

    getStations = () => {
        return this.props.job.parameters.parameters.map((v) => ({ credentials: { value: v, noPadding: 'yes' } }))
    }

    handleChangeDataIntegration = integration => {
        const { parameters } = this.props.job
        const dataTypes = (() => {
            const data = parameters.dataTypes.filter(d => !d.includes('data'))
            if (integration) {
                return [...data, integration]
            }
            return data
        })()
        this.props.onChangeDataTypes(dataTypes)
    }

    handleChangeStationIntegration = integration => {
        const { parameters } = this.props.job
        const dataTypes = (() => {
            const data = parameters.dataTypes.filter(d => !d.includes('station'))
            if (integration) {
                return [...data, 'stationIntegration']
            }
            return data
        })()
        this.props.onChangeDataTypes(dataTypes)
    }

    onChangeFilters = (changes) => {
        const parameters = {
            ...this.props.job.parameters,
            filters: [JSON.stringify({
                ...this.getFilters(),
                ...changes,
            })],
        }
        this.props.onChangeJob({ parameters })
    }

    getFilters = () => {
        const newFilters = this.props.job.parameters.filters.length ? JSON.parse(this.props.job.parameters.filters[0]) : {}
        return {
            height: true,
            forecastTide: true,
            surcharge: true,
            importMode: 'DATA_ADD_NEW_DATA',
            ...newFilters }
    }
    getOptionHauteur = () => {
        return [{
            id: 4,
            label: i18n.height,
        }]
    }

    render() {
        const disabled = { disabled: !this.props.isEditMode }
        const filters = this.getFilters()
        const myData =this.getStations()
        const shomDataTypes = ['height', 'forecastTide', 'surcharge', 'surchargeandforecast', 'surchargeReal', 'tide']

        const dataTypes = shomDataTypes.map(shomDt => {
            return (shomDt === 'height') ?
                {
                    nullValue: <Checkbox checked={ filters[shomDt] } onChange={ v => this.onChangeFilters({ [shomDt]: v }) } { ...disabled } />,
                    name: i18n[shomDt],
                    dataType: <Select value={ filters[`${shomDt}Dt`] } options={ this.getOptionHauteur() } onChange={ v => this.onChangeFilters({ [`${shomDt}Dt`]: v })} { ...disabled }/>,
                }
                : (shomDt === 'tide') ?
                    {
                        nullValue: <Checkbox checked={ filters[shomDt] } onChange={ v =>this.onChangeFilters({ [shomDt]: v }) } {...disabled} />,
                        name: i18n.tide,
                        datatype: '',
                    }:
                    {
                        nullValue: <Checkbox checked={ filters[shomDt] } onChange={ v => this.onChangeFilters({ [shomDt]: v }) } { ...disabled } />,
                        name: i18n[shomDt],
                        dataType: <Select value={ filters[`${shomDt}Dt`] } options={ this.props.hydrometryDataTypes } onChange={ v => this.onChangeFilters({ [`${shomDt}Dt`]: v })} { ...disabled }/>,
                    }
        })
        return (
            <Stack spacing={1}>
                <Grid container spacing={1}>
                    <Grid size={3} paddingTop={2}>
                        <Checkbox
                            checked={ filters.stationIntegration }
                            label={ i18n.integrateStationInfo }
                            onChange={ v => this.onChangeFilters({ stationIntegration: v }) }
                            { ...disabled }
                        />
                    </Grid>
                    <Grid size={4}>
                        <Select
                            options={ getIntegrationModes() }
                            obligatory={true}
                            label={ i18n.dataIntegration }
                            value={ filters.importMode }
                            labelSpan={ <IntegrationModeDialog /> }
                            onChange={ v => this.onChangeFilters({ importMode: v }) }
                            { ...disabled }
                        />

                    </Grid>
                    <Grid size={3} paddingTop={2}>
                        <Checkbox
                            checked={filters.withEvents }
                            label={ i18n.importEvents }
                            onChange={ v => this.onChangeFilters({ withEvents: v }) }
                            { ...disabled }
                        />
                    </Grid>
                </Grid>
                <FieldsetMUI title={i18n.defaultValue}>
                    <Grid container spacing={1}>
                        <Grid size={3}>
                            <Select
                                label={ i18n.status }
                                value={ filters.status }
                                onChange={ v => this.onChangeFilters({ status: v }) }
                                options={ getStatusSelectOptions() }
                                nullLabel='&nbsp;'
                                { ...disabled }
                            />
                        </Grid>
                        <Grid size={3}>
                            <Select
                                label={ i18n.qualification }
                                value={ filters.qualification }
                                onChange={ v => this.onChangeFilters({ qualification: v }) }
                                options={ getQualificationSelectOptions() }
                                nullLabel='&nbsp;'
                                { ...disabled }
                            />
                        </Grid>
                        <Grid size={6}>
                            <MultiContributorsAutocomplete
                                label={ i18n.producer }
                                values={ filters.producer }
                                onChange={ v => this.onChangeFilters({ producer: v }) }
                                options={ this.props.contributors }
                                { ...disabled }
                            />
                        </Grid>
                        <Grid size={3}>
                            <Select
                                label={ i18n.measureNature }
                                value={ filters.nature }
                                onChange={ v => this.onChangeFilters({ nature: v }) }
                                options={ getSandreList(this.props.sandreCodes, SANDRE.PIEZOMETER_MEASURE_NATURE, true) }
                                nullLabel='&nbsp;'
                                { ...disabled }
                            />

                        </Grid>
                        <Grid size={3}>
                            <Select
                                label={ i18n.obtainningMode }
                                value={ filters.obtainingMode }
                                onChange={ v => this.onChangeFilters({ obtainingMode: v }) }
                                options={ getSandreList(this.props.sandreCodes, SANDRE.OBTAINING_MODE) }
                                nullLabel='&nbsp;'
                                { ...disabled }
                            />

                        </Grid>
                        <Grid size={3}>
                            <MultiContributorsAutocomplete
                                label={ i18n.administrator }
                                values={ filters.manager }
                                onChange={ v => this.onChangeFilters({ manager: v }) }
                                options={ this.props.contributors }
                                { ...disabled }
                            />

                        </Grid>
                        <Grid size={3}>
                            <MultiContributorsAutocomplete
                                label={ i18n.validator }
                                values={ filters.validator }
                                onChange={ v => this.onChangeFilters({ validator: v }) }
                                options={ this.props.contributors }
                                { ...disabled }
                            />
                        </Grid>
                    </Grid>
                </FieldsetMUI>
                <FieldsetMUI title={i18n.dataTypes}>
                    <NewTable
                        rows={ dataTypes }
                        headers={ ['nullValue', 'name', 'dataType'] }
                    />
                </FieldsetMUI>
                <Grid container spacing={1}>
                    <Grid size={3} paddingTop={1}>
                        <Typography>{ i18n.addCredential }</Typography>
                    </Grid>
                    <Grid size={6} spacing={1}>
                        <Input
                            title={i18n.tidegaugeCode}
                            placeholder={i18n.tidegaugeExample}
                            value={this.state.addCode}
                            onChange={value => this.setState({ addCode: value })}
                            {...disabled}
                        />
                    </Grid>
                    <Grid size={3} paddingTop={1}>
                        <Button
                            variant='contained'
                            fullWidth
                            onClick={ this.addCode }
                            { ...disabled }
                        >
                            {i18n.add}
                        </Button>
                    </Grid>
                </Grid>
                <CardTable
                    rows={ myData }
                    headers={ ['credentials']}
                    title={ i18n.credentials }
                    lineActions={[{
                        icon: 'delete',
                        onClick: (s) => this.onDeleteCode(s),
                        displayed: this.props.isEditMode,
                    }]}
                    rowsPerPageOptions={ nbPerPageLabelMedium }
                    data-cy='EtatEco_table_body'
                    actions={[{
                        icon: 'download',
                        onClick: () => exportFile({
                            data: [{ ...(myData[0]), headers: ['credentials'] }, ...(myData.slice(1, myData.length))],
                            titleFile: i18n.credentials,
                        }),
                        tooltip: i18n.download,
                    }]}
                    displayHeaders={false}
                />
            </Stack>
        )
    }
}

TideGaugePanel.propTypes = {
    job: PropTypes.instanceOf(Job).isRequired,
    addCode: PropTypes.func.isRequired,
    isEditMode: PropTypes.bool,
    onChangeDataTypes: PropTypes.func,
    onChangeJob: PropTypes.func.isRequired,
    toastrError: PropTypes.func,
    hydrometryDataTypes: arrayOf(DtoParametrageDataType),
    fetchHydrometryDataTypes: PropTypes.func,
    sandreCodes: arrayOf(DtoSandreCode),
    contributors: arrayOf(DtoContributor),
    fetchSandreCodes: PropTypes.func,
}

const mapDispatchToProps = {
    toastrError: ToastrAction.error,
    fetchHydrometryDataTypes: HydrometryAction.fetchHydrometryDataTypes,
    fetchSandreCodes: ReferencialAction.fetchSandreCodes,
}
const mapStateToProps = store => ({
    hydrometryDataTypes: store.HydrometryReducer.hydrometryDataTypes,
    sandreCodes: store.ReferencialReducer.sandreCodes,
    contributors: store.ContributorReducer.contributors,
})

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(TideGaugePanel)
